import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { FacebookPixelServiceService } from "../../services/facebook-pixel-service.service";
import { NgbDateCustomParserFormatter } from "../filters/dateformat";
import { Observable, of } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  tap,
  switchMap,
} from "rxjs/operators";
import {
  NgbDateStruct,
  NgbCalendar,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { isString } from "util";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-form-finance",
  templateUrl: "./form-finance.component.html",
  styleUrls: ["./form-finance.component.css"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
  ],
})
export class FormFinanceComponent implements OnInit {
  pixelUrl: SafeResourceUrl =
    "https://e-leads.g2afse.com/success.php?offer_id=33";
  pixelUrlNew: SafeResourceUrl = "https://trk.elds.it?offer_id=33";
  params: any = {};
  leadDouble: boolean = false;
  minAmount: any = 5000;
  maxAmount: any = 75000;
  privacyConsent: boolean = false;
  lead: any = {
    type: "",
    job: "",
    birthday: {
      day: "",
      month: "",
      year: "",
    },
  };
  birthday;

  days: any = [];
  months: any = [
    {
      description: "Gennaio",
      value: 1,
    },
    {
      description: "Febbraio",
      value: 2,
    },
    {
      description: "Marzo",
      value: 3,
    },
    {
      description: "Aprile",
      value: 4,
    },
    {
      description: "Maggio",
      value: 5,
    },
    {
      description: "Giugno",
      value: 6,
    },
    {
      description: "Luglio",
      value: 7,
    },
    {
      description: "Agosto",
      value: 8,
    },
    {
      description: "Settembre",
      value: 9,
    },
    {
      description: "Ottobre",
      value: 10,
    },
    {
      description: "Novembre",
      value: 11,
    },
    {
      description: "Dicembre",
      value: 12,
    },
  ];
  years: any = [];

  lastResults: any = [];

  maxDate: NgbDateStruct = {
    day: new Date().getDay(),
    month: new Date().getMonth(),
    year: new Date().getFullYear() - 18,
  };
  minDate: NgbDateStruct = {
    day: 1,
    month: 1,
    year: 1910,
  };
  buyerFound: boolean = true;
  showSMS: boolean = false;
  showCall: boolean = false;
  leadId: string;
  searching: boolean = false;
  errors: any = [];
  nextStep = false;
  stepCount = 0;
  loading: boolean = false;
  code: string = "";
  error: boolean = false;
  editPhone: boolean = false;
  color: string = "#28a745"; // hover color #218838
  bgColor: string = this.color;
  buyer: any = {};
  oldBuyers: any = [];
  affise_offer_id: string;

  jobs: any;

  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private api: ApiService,
    private calendar: NgbCalendar,
    private fb: FacebookPixelServiceService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.params = params;
      this.lead.affiliate = this.params.aff_id;
      this.lead.host = this.params.host;
      this.lead.aff_ref = this.params.aff_ref;
      this.lead.url = this.params.url;

      if (this.params.type && this.params.type !== "finance") {
        this.lead.type = params.type;
      }

      if (this.params.btn_color) {
        this.color = this.params.btn_color;
        this.bgColor = this.params.btn_color;
      }

      let paramLead;
      if (this.params.lead) {
        paramLead = JSON.parse(this.params.lead);
        console.log(paramLead);
      }

      if (paramLead) {
        this.lead.name = paramLead.name;
        this.lead.surname = paramLead.surname;
        this.lead.phone = paramLead.phone;
        this.lead.job = paramLead.job;
        this.errors["phone"] = this.eleads_validate_phone(this.lead.phone);
        this.lead.email = paramLead.email;
        this.errors["email"] = this.eleads_validate_email(this.lead.email);
      }

      for (let i = 1; i <= 31; i++) {
        this.days.push({ value: i, description: i });
      }

      for (let i = 1900; i <= this.maxDate.year; i++) {
        this.years.push({ value: i, description: i });
      }
      this.years.reverse();

      try {
        if (localStorage.getItem("el_oldBuyers")) {
          this.oldBuyers = JSON.parse(localStorage.getItem("el_oldBuyers"));
        }

        if (localStorage.getItem("userFinance")) {
          const lead = JSON.parse(localStorage.getItem("userFinance"));

          if (lead.owner !== "eleads") {
            this.oldBuyers.push(lead.owner);
          }
        }
      } catch (e) {
        console.error(e);
      }

      this.lead.amount = 0;

      switch (this.params.type) {
        case "finance-professionisti":
          this.minAmount = 15000;
          this.maxAmount = 150000;
          break;

        case "rimborso":
          this.minAmount = 0;
          this.maxAmount = 100000;
          this.lead.amount = 0;
          this.lead.layoff = false;
          this.lead.segnalato = false;
          this.stepCount = 1;
          break;

        default:
          this.lead.layoff = false;
          break;
      }

      this.setupJobs();
    });

    this.cd.detectChanges();
  }

  setupJobs() {
    if (this.lead.type === "cessione") {
      this.jobs = [
        // { id: 9, description: 'Dipendente agenzia interinale', value: 'interinale' },
        { id: 4, description: "In cerca di occupazione", value: "disoccupato" },
        {
          id: 4,
          description: "Dipendente cooperativa (indeterminato)",
          value: "cooperativa",
        },
        { id: 2, description: "Dipendente parastatale", value: "parastatale" },
        { id: 1, description: "Dipendente pubblico", value: "pubblico" },
        { id: 8, description: "Dipendente SNC/SAS", value: "snc" },
        { id: 5, description: "Dipendente SPA (indeterminato)", value: "spa" },
        { id: 6, description: "Dipendente SRL (indeterminato)", value: "srl" },
        { id: 0, description: "Dipendente statale", value: "statale" },
        // { id: 0, description: 'Disoccupato', value: 'disoccupato' },
        { id: 3, description: "Lavoratore autonomo", value: "autonomo" },
        { id: 3, description: "Militare", value: "militare" },
        { id: 7, description: "Pensionato", value: "pensionato" },
        { id: 7, description: "Altro", value: "altro" },
      ];
    } else {
      this.jobs = [
        // { id: 9, description: 'Dipendente agenzia interinale', value: 'interinale' },
        { id: 4, description: "In cerca di occupazione", value: "disoccupato" },
        {
          id: 4,
          description: "Dipendente cooperativa (indeterminato)",
          value: "cooperativa",
        },
        { id: 2, description: "Dipendente parastatale", value: "parastatale" },
        { id: 1, description: "Dipendente pubblico", value: "pubblico" },
        { id: 8, description: "Dipendente SNC/SAS", value: "snc" },
        { id: 5, description: "Dipendente SPA (indeterminato)", value: "spa" },
        { id: 6, description: "Dipendente SRL (indeterminato)", value: "srl" },
        { id: 0, description: "Dipendente statale", value: "statale" },
        // { id: 0, description: 'Disoccupato', value: 'disoccupato' },
        { id: 3, description: "Lavoratore autonomo", value: "autonomo" },
        { id: 3, description: "Militare", value: "militare" },
        { id: 7, description: "Pensionato", value: "pensionato" },
        { id: 7, description: "Altro", value: "altro" },
      ];
    }
  }

  check(property) {
    let amount = 0;

    switch (property) {
      case "gender":
        if (this.lead.gender) {
          this.errors["gender"] = false;
        } else {
          this.errors["gender"] = true;
        }

        break;

      case "type":
        if (this.lead.type !== "") {
          this.errors["type"] = false;
        } else {
          this.errors["type"] = true;
        }

        break;

      case "job":
        if (this.lead.job) {
          this.errors["job"] = false;

          this.lead.job_info = "";
          //this.lead.layoff = (this.lead.type === "cessione") ? undefined : this.lead.layoff;
          if (this.lead.job && this.lead.zip && this.lead.type) {
            this.getSetup(
              this.lead.job,
              this.lead.job_info,
              this.lead.zip.zipcode,
              this.lead.type,
              this.lead.affiliate,
              this.lead.birthday,
              this.lead.amount,
              this.lead.layoff,
              this.lead.closedCQ
            );
          }
        } else {
          this.errors["job"] = true;
        }

        break;
        /* 
      case "segnalato":
        if (this.lead.segnalato !== undefined) {
          this.errors["segnalato"] = false;
        } else {
          this.errors["segnalato"] = true;
        }

        break;
 */
        /* 
      case 'layoff':

        if (this.lead.layoff !== undefined) {
          this.errors['layoff'] = false;

          if (this.lead.job && this.lead.zip && this.lead.type) {
            this.getSetup(this.lead.job, this.lead.job_info, this.lead.zip.zipcode, this.lead.type, this.lead.affiliate, this.lead.birthday, this.lead.amount, this.lead.layoff, this.lead.closedCQ);
          }

        } else {
          this.errors['layoff'] = true;
        } */

        break;
      /* 
            case 'closedCQ':
      
              if (this.lead.closedCQ !== undefined) {
                this.errors['closedCQ'] = false;
      
                if (this.lead.job && this.lead.zip && this.lead.type) {
                  this.getSetup(this.lead.job, this.lead.job_info, this.lead.zip.zipcode, this.lead.type, this.lead.affiliate, this.lead.birthday, this.lead.amount, this.lead.layoff, this.lead.closedCQ);
                }
      
              } else {
                this.errors['closedCQ'] = true;
              }
      
      
              break;
       */
      case "job_info":
        let needInfo = [
          "cooperativa",
          "srl",
          "spa",
          "pensionato",
          "ditta",
          "professionista",
        ];

        if (needInfo.includes(this.lead.job)) {
          if (this.lead.job_info) {
            this.errors["job_info"] = false;

            if (this.lead.job && this.lead.zip && this.lead.type) {
              this.getSetup(
                this.lead.job,
                this.lead.job_info,
                this.lead.zip.zipcode,
                this.lead.type,
                this.lead.affiliate,
                this.lead.birthday,
                this.lead.amount,
                this.lead.layoff,
                this.lead.closedCQ
              );
            }
          } else {
            this.errors["job_info"] = true;
          }
        }

        break;

      /*    case 'amount':

        if (amount >= this.minAmount && amount <= this.maxAmount) {
          this.errors['amount'] = false;
        } else {
          this.errors['amount'] = true;
        }

        break; */

      case "name":
        if (this.lead.name.length >= 2) {
          this.errors["name"] = false;
        } else {
          this.errors["name"] = true;
        }

        break;

      case "surname":
        if (this.lead.surname.length >= 2) {
          this.errors["surname"] = false;
        } else {
          this.errors["surname"] = true;
        }

        break;

      case "birthday":
        const maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if (
          this.lead.birthday.year >= 1900 &&
          this.lead.birthday.year < this.maxDate.year &&
          this.lead.birthday.month > 0 &&
          this.lead.birthday.month <= 12 &&
          this.lead.birthday.day > 0 &&
          this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1]
        ) {
          this.errors["birthday"] = false;
        } else {
          this.errors["birthday"] = true;
        }

        break;

      case "email":
        this.errors["email"] = this.eleads_validate_email(this.lead.email);
        break;

      case "vatNumber":
        this.errors["vatNumber"] = this.eleads_validate_vatNumber(
          this.lead.vatNumber
        );
        break;

      case "phone":
        this.errors["phone"] = this.eleads_validate_phone(this.lead.phone);
        break;

      case "zip":
        if (this.lead.zip.name && this.lead.zip.zipcode) {
          this.errors["zip"] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.zip = this.lastResults[0];
          this.getSetup(
            this.lead.job,
            this.lead.job_info,
            this.lead.zip.zipcode,
            this.lead.type,
            this.lead.affiliate,
            this.lead.birthday,
            this.lead.amount,
            this.lead.layoff,
            this.lead.closedCQ
          );
          this.errors["zip"] = false;
        } else {
          this.errors["zip"] = true;
        }

        break;

      case "hometown":
        if (this.lead.hometown.name && this.lead.hometown.zipcode) {
          this.errors["hometown"] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.hometown = this.lastResults[0];
          this.errors["hometown"] = false;
        } else {
          this.errors["hometown"] = true;
        }
        break;

      default:
        if (this.lead[property] !== "") {
          this.errors[property] = false;
        } else {
          this.errors[property] = true;
        }
        break;
    }
  }

  getSetup(
    job,
    job_info,
    zipcode,
    type,
    affiliate_id,
    birthday,
    amount,
    layoff,
    closedCQ
  ) {
    this.loading = true;
    if (job_info) {
      job = job.concat(job_info);
    }
    this.api
      .setupFinance(
        job,
        zipcode,
        type,
        affiliate_id,
        this.oldBuyers,
        birthday,
        amount,
        layoff,
        closedCQ
      )
      .subscribe(
        (data) => {
          this.buyer = data;
          this.lead.owner = this.buyer.id;
          this.lead.needToQualify = data.needToQualify;
          this.lead.needToVerify = data.needToVerify;
          this.buyerFound = true;

          if (data.blocked) {
            this.lead.affiliate = "";
          }

          this.loading = false;
        },
        (error) => {
          this.buyerFound = false;
          this.loading = false;
        }
      );
  }

  formatMatches = (value: any) => value.zipcode + " - " + value.name || "";
  formatMatchesInput = (value: any) => value.zipcode || "";
  selectedItem(item) {
    this.lead.city = item.item.name;
    this.errors["zip"] = false;
    this.getSetup(
      this.lead.job,
      this.lead.job_info,
      item.item.zipcode,
      this.lead.type,
      this.lead.affiliate,
      this.lead.birthday,
      this.lead.amount,
      this.lead.layoff,
      this.lead.closedCQ
    );
  }

  formatMatchesHometown = (value: any) =>
    value.zipcode + " - " + value.name || "";
  formatMatchesInputHometown = (value: any) => value.zipcode || "";
  selectedItemHometown(item) {
    this.lead.hometown = item.item.name;
    this.errors["hometown"] = false;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.api.getLocation(term).pipe(
          tap((obj: any) => {
            this.lastResults = [];
            this.lastResults = obj;
          }),
          catchError(() => {
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );

  searchHometown = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.api.getLocation(term).pipe(
          tap((obj: any) => {
            this.lastResults = [];
            this.lastResults = obj;
          }),
          catchError(() => {
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );

  eleads_validate_vatNumber(vatNumber) {
    vatNumber = vatNumber.replace(/ /g, "");
    var re = /^[0-9]{11}$/;
    return !re.test(String(vatNumber).toLowerCase());
  }

  eleads_validate_email(email) {
    email = email.replace(/ /g, "");
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(email).toLowerCase());
  }

  eleads_validate_phone(phone) {
    phone = phone.replace(/ /g, "");
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,6}$/im;
    return !re.test(String(phone).toLowerCase());
  }

  eleads_validate_cap(cap) {
    var re = /^[0-9]{5}$/;
    return !re.test(String(cap).toLowerCase());
  }

  verify() {
    this.loading = true;
    var code = { code: this.code };
    this.api.verifyFinance(this.leadId, code).subscribe(
      (success) => {
        this.loading = false;
        this.oldBuyers.push(this.buyer.id);

        let goal;
        switch (this.lead.job + this.lead.job_info) {
          case "pubblico":
          case "statale":
          case "pensionatoanzianita":
          case "parastatale":
          case "militare":
            goal = "pubblico-basic";
            break;

          case "cooperativapiu50":
          case "srlpiu15":
          case "spapiu15":
            goal = "privato-basic";
            break;

          default:
            goal = "privatomeno15-basic";
            break;
        }

        this.pixelUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          "https://e-leads.g2afse.com/success.php?offer_id=33&afgoal=" +
            goal +
            "&custom_field1=" +
            this.leadId +
            "&afstatus=1" +
            "&custom_field2=" +
            this.lead.aff_ref
        );
        this.pixelUrlNew = this.sanitizer.bypassSecurityTrustResourceUrl(
          "https://trk.elds.it/success.php?offer_id=33&afgoal=" +
            goal +
            "&custom_field1=" +
            this.leadId +
            "&afstatus=1" +
            "&custom_field2=" +
            this.lead.aff_ref
        );

        this.stepCount++;

        let sold = true;

        let normalQuality = ["cooperativa", "srl"];

        let topQuality = [
          "parastatale",
          "pubblico",
          "militare",
          "pensionato",
          "statale",
          "spa",
        ];

        let quality = "normal";

        if (topQuality.includes(this.lead.job)) {
          quality = "top";
        }

        if (
          !topQuality.includes(this.lead.job) &&
          !normalQuality.includes(this.lead.job)
        ) {
          quality = "low";
        }

        if (this.buyer.id === "eleads") {
          sold = false;
        } else {
          localStorage.setItem("el_oldBuyers", JSON.stringify(this.oldBuyers));
        }

        window.setTimeout(() => {
          window.parent.postMessage(
            {
              sender: "e-leads",
              message: "done",
              id: this.leadId,
              double: this.leadDouble,
              sold,
              quality,
              logo: this.buyer.logo,
              qualify: this.lead.needToQualify,
              goal,
            },
            "*"
          );
        }, 2000);
      },
      (error) => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  next() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    let amount = 0; //(isString(this.lead.amount)) ? parseInt(this.lead.amount.replace(/\./g, "")) : this.lead.amount;
    var goOn = true;
    switch (this.stepCount) {
      case 0:
        let needInfo = [
          "cooperativa",
          "srl",
          "spa",
          "pensionato",
          "ditta",
          "professionista",
        ];

        let needLayoff = ["cooperativa", "srl", "spa"];

        /*   if (amount >= this.minAmount && amount <= this.maxAmount) {
          this.errors['amount'] = false;
        } else {
          goOn = false;
          this.errors['amount'] = true;
        } */

        if (this.lead.type == "") {
          goOn = false;
          this.errors["type"] = true;
        } else {
          this.errors["type"] = false;
        }

        if (this.lead.job == "") {
          goOn = false;
          this.errors["job"] = true;
        } else {
          this.errors["job"] = false;
        }

     

        /*    if (this.lead.closedCQ !== undefined) {
             this.errors['closedCQ'] = false;
           } else {
             this.errors['closedCQ'] = true;
             goOn = false;
           } */

        if (needInfo.includes(this.lead.job)) {
          if (!this.lead.job_info) {
            this.errors["job_info"] = true;
            goOn = false;
          } else {
            this.errors["job_info"] = false;
          }
        } else {
          this.errors["job_info"] = true;
        }
        /* 
        if (needLayoff.includes(this.lead.job)) {
          if (this.lead.layoff !== undefined) {
            this.errors['layoff'] = false;
          } else {
            this.errors['layoff'] = true;
            goOn = false;
          }
        } */

        if (this.lead.type == "finance-professionisti") {
          if (!this.lead.vatNumber || this.errors["vatNumber"]) {
            goOn = false;
            this.errors["vatNumber"] = true;
          } else {
            this.errors["vatNumber"] = false;
          }
        }

        if (!this.privacyConsent) {
          goOn = false;
          this.errors["privacyConsent"] = true;
        } else {
          this.errors["privacyConsent"] = false;
        }

        if (goOn) {
          //this.lead.amount = amount;
          this.stepCount++;
          window.scrollTo(0, 0);
        }
        break;

        if (this.lead.type == "rimborso") {
          let needInfo = [
            "cooperativa",
            "srl",
            "spa",
            "pensionato",
            "ditta",
            "professionista",
          ];

          if (this.lead.job == "") {
            goOn = false;
            this.errors["job"] = true;
          } else {
            this.errors["job"] = false;
          }

          if (needInfo.includes(this.lead.job)) {
            if (!this.lead.job_info) {
              this.errors["job_info"] = true;
              goOn = false;
            } else {
              this.errors["job_info"] = false;
            }
          } else {
            this.errors["job_info"] = true;
          }
        }

        if (!this.lead.gender) {
          goOn = false;
          this.errors["gender"] = true;
        } else {
          this.errors["gender"] = false;
        }

        if (!this.lead.name || this.errors["name"]) {
          goOn = false;
          this.errors["name"] = true;
        } else {
          this.errors["name"] = false;
        }

        if (!this.lead.surname || this.errors["surname"]) {
          goOn = false;
          this.errors["surname"] = true;
        } else {
          this.errors["surname"] = false;
        }

        var maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if (
          this.lead.birthday.year >= 1900 &&
          this.lead.birthday.year < this.maxDate.year &&
          this.lead.birthday.month > 0 &&
          this.lead.birthday.month <= 12 &&
          this.lead.birthday.day > 0 &&
          this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1]
        ) {
          this.errors["birthday"] = false;
        } else {
          this.errors["birthday"] = true;
          goOn = false;
        }

        if (goOn) {
          this.stepCount++;
          this.fb.track("step_1");
          this.birthday = this.lead.birthday;
          window.scrollTo(0, 0);
        }
        break;

      case 1:
        if (!this.lead.zip || this.errors["zip"]) {
          goOn = false;
          this.errors["zip"] = true;
        } else {
          this.errors["zip"] = false;
        }

        if (this.buyer.fiscalCode) {
          if (!this.lead.hometown || this.errors["hometown"]) {
            goOn = false;
            this.errors["hometown"] = true;
          } else {
            this.errors["hometown"] = false;
          }
        }

        if (goOn) {
          this.stepCount++;
          this.fb.track("step_2");
          window.scrollTo(0, 0);
        }
        break;

      case 2:
        if (!this.lead.phone || this.errors["phone"]) {
          goOn = false;
          this.errors["phone"] = true;
        } else {
          this.errors["phone"] = false;
        }

        if (!this.lead.email || this.errors["email"]) {
          goOn = false;
          this.errors["email"] = true;
        } else {
          this.errors["email"] = false;
        }

        if (this.buyer.id == "eleads") {
          if (!this.lead.privacy_data) {
            goOn = false;
            this.errors["privacy_data"] = true;
          } else {
            this.errors["privacy_data"] = false;
          }
        } else {
          this.buyer.privacies.map((privacy) => {
            if (privacy.required) {
              if (!this.lead[privacy.paramName]) {
                goOn = false;
                this.errors[privacy.paramName] = true;
              } else {
                this.errors[privacy.paramName] = false;
              }
            }
          });
        }

        /* if (
          this.lead.job_info === "meno15" ||
          this.lead.job_info === "meno50"
        ) {
          if (this.lead.segnalato !== undefined) {
            this.errors["segnalato"] = false;
          } else {
            this.errors["segnalato"] = true;
            goOn = false;
          }
        } */

        if (goOn) {
          this.loading = true;
          var lead = this.lead;
          lead.cap = lead.zip.zipcode;
          this.api.postLeadFinance(this.lead).subscribe(
            (id: any) => {
              if (this.lead.needToVerify) {
                this.leadId = id.id;
                (this.leadDouble = id.double), this.stepCount++;
                this.loading = false;
                this.api.sendSMSFinance(this.leadId).subscribe();

                this.pixelUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                  "https://e-leads.g2afse.com/success.php?offer_id=33&afgoal=inverifica&custom_field1=" +
                    this.leadId +
                    "&afstatus=1" +
                    "&custom_field2=" +
                    this.lead.aff_ref
                );

                window.parent.postMessage(
                  {
                    sender: "e-leads",
                    message: "verify",
                    id: this.leadId,
                    logo: this.buyer.logo,
                  },
                  "*"
                );
              } else {
                this.leadId = id.id;
                this.loading = false;
                let sold = this.buyer.id !== "eleads" ? true : false;

                let goal;
                switch (this.lead.job + this.lead.job_info) {
                  case "pubblico":
                  case "statale":
                  case "pensionatoanzianita":
                  case "parastatale":
                  case "militare":
                    goal = "pubblico-prequalificato";
                    break;

                  case "cooperativapiu50":
                  case "srlpiu15":
                  case "spapiu15":
                    goal = "privato-prequalificato";
                    break;

                  default:
                    goal = "privatomeno15-prequalificato";
                    break;
                }

                this.pixelUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                  "https://e-leads.g2afse.com/success.php?offer_id=33&afgoal=" +
                    goal +
                    "&custom_field1=" +
                    this.leadId +
                    "&afstatus=2" +
                    "&custom_field2=" +
                    this.lead.aff_ref
                );
                this.pixelUrlNew =
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    "https://trk.elds.it/success.php?offer_id=33&afgoal=" +
                      goal +
                      "&custom_field1=" +
                      this.leadId +
                      "&afstatus=1" +
                      "&custom_field2=" +
                      this.lead.aff_ref
                  );

                this.stepCount += 2;

                let normalQuality = ["cooperativa", "srl"];

                let topQuality = [
                  "parastatale",
                  "pubblico",
                  "militare",
                  "pensionato",
                  "statale",
                  "spa",
                ];

                let quality = "normal";

                if (topQuality.includes(this.lead.job)) {
                  quality = "top";
                }

                if (
                  !topQuality.includes(this.lead.job) &&
                  !normalQuality.includes(this.lead.job)
                ) {
                  quality = "low";
                }

                window.setTimeout(() => {
                  window.parent.postMessage(
                    {
                      sender: "e-leads",
                      message: "done",
                      id: this.leadId,
                      sold,
                      double: this.leadDouble,
                      quality,
                      logo: this.buyer.logo,
                      qualify: this.lead.needToQualify,
                      goal,
                    },
                    "*"
                  );
                }, 2000);
              }

              this.fb.track("form_compilato");

              window.scrollTo(0, 0);
            },
            (error) => {
              this.loading = false;
              this.error = true;
              window.scrollTo(0, 0);
            }
          );
        }
        break;

      case 4:
        break;

      default:
        break;
    }
  }

  sendSMS() {
    var phone = { phone: this.lead.phone };
    this.api.editPhoneFinance(this.leadId, phone).subscribe((success) => {
      this.api.sendSMSFinance(this.leadId).subscribe(
        (success) => {
          this.showSMS = true;
        },
        (error) => {
          this.error = true;
        }
      );
    });
  }

  sendCall() {
    var phone = { phone: this.lead.phone };
    this.api.editPhoneFinance(this.leadId, phone).subscribe(
      (success) => {
        this.api.sendCallFinance(this.leadId).subscribe(
          (success) => {
            this.showCall = true;
          },
          (error) => {
            this.error = true;
          }
        );
      },
      (error) => {
        this.error = true;
      }
    );
  }

  prev() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    this.stepCount--;
  }

  checkData(step) {
    var goOn = false;
    switch (step) {
      case 0:
        break;
    }
  }

  registerClick() {
    this.api.registerClick(this.leadId, this.buyer.id).subscribe();
  }

  mouseEnter() {
    var rgb = this.hexToRgb(this.color);

    // create a darker shade for hover effect
    rgb.r *= 0.8;
    rgb.g *= 0.8;
    rgb.b *= 0.8;

    this.bgColor = this.rgbToHex(rgb.r, rgb.g, rgb.b);
  }

  mouseLeave() {
    this.bgColor = this.color;
  }

  //-------------------------------- FUNCTION TO TRANSFORM HEX COLOR TO RGB AND BACK

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  rgbToHex(red, green, blue) {
    var rgb = blue | (green << 8) | (red << 16);
    return "#" + (0x1000000 + rgb).toString(16).slice(1);
  }

  public onFocusSelect(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event("input");
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }
}
